import React from 'react';

const How: React.FC = () => {
    return(
        <div className='home-background'>
            <div className='fair-info'>
                <div className='fair-info-inner'>
                    <div className='fair-info-text'>
                        <h1>How do I set up a poll?</h1>
                        <p>
                        1. From the landing page, click on "create a new poll"
                        </p>
                        <p>
                        2. Fill in the object of the election and the candidate options who are running in the election
                        </p>
                        <p>
                        3. Publish the poll and send it to all the voters by typing their email addresses
                        </p>
                    </div>
                </div>
            </div>
            <div className='crv-info'>
                <div className='crv-info-inner'>
                    <div className='crv-info-text'>
                        <h1>How do I vote?</h1>
                        <p>
                        1. When you're invited to vote you will receive an email with an encrypted token and a URL for the specific election you're invited to vote in<br/><br/>
                        2. Once you click on the link you'll be redirected to the election page that explains the object of the election and shows you all the candidates<br/><br/>
                        3. Drag and drop your most favorite candidate to the top of the list, go back and drag your second-favorite candidate to the second position in the list, and so on, with all the candidates according to your preference. You can always leave your least favorite candidates with no ranking
                        </p>
                    </div>
                </div>
            </div>
            <div className='fair-info'>
                <div className='fair-info-inner'>
                    <div className='fair-info-text'>
                        <h1>How do you calculate the vote?</h1>
                        <p>
                        1. Once the poll is closed, we tally all the votes and look for a candidate that has more than 50% of the vote. <br/><br/>
                        2. When none of the candidates has a majority, we look for the least favorite candidate and eliminate them from the race.<br/><br/>
                        3. We have a second round of calculating the votes after removing the least favorite candidate, and repeat steps 1 and 2 until we have a candidate with a majority (more than 50%) of the vote. That is the winner of the race
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default How;

